import companyLogo from "../../../images/freshworks-icon.png";
import MoreIcon from "../../../images/more-horizontal.png";
import { LuCalendar } from "react-icons/lu";
import { HiArrowLeft } from "react-icons/hi";
import dayjs from "dayjs";
import {
  Menu,
  MenuItem,
  ThemeProvider,
  alpha,
  createTheme,
  styled,
} from "@mui/material";
import { BorderColorOutlined, DeleteOutline } from "@mui/icons-material";
import { IMAGE_BASE_URL } from "../../../helpers/constants";

const SlotItem = (props) => {
  const {
    item,
    itemIndex,
    handleCloseMenu,
    handleOpenDel,
    open,
    anchorEl,
    handleClick,
    showSlot,
    type = "loanProvider",
    pagePermission,
  } = props;
  //console.log({ item });
  return (
    <div className="w-[260px] min-[500px]:w-[310px] bg-white min-[500px]:border min-[500px]:border-1 rounded-md flex items-center">
      <div className="max-[500px]:hidden block text-[12px] p-2 px-2 text-[#0F0F0F] font-medium flex flex-col items-center justify-center p-1 ">
        <div className=" w-[35px] flex items-center justify-center">
          {itemIndex === 0 ? (
            <div className="text-center">
              <span>Slot</span>
              <br />
              {item?.slot}
            </div>
          ) : (
            <HiArrowLeft size={15} color="#0560FB" />
          )}
        </div>
      </div>
      <div className="flex flex-1 items-center rounded-md p-2 pr-2 min-[500px]:border-l max-[500px]:border">
        <div className="border border-1 rounded-md border-[#DFDFDF] overflow-hidden">
          <img
            className="w-9"
            src={`${IMAGE_BASE_URL}/${
              type == "loanProvider"
                ? item.loanproviderinfo?.icon
                : item.agentinfo?.icon
            }`}
            alt="logo"
          />
        </div>
        <div className="pl-2 flex-grow flex-shrink-0">
          <h1 className="text-[13px] text-black">
            {(type == "loanProvider" && item.loanproviderinfo?.name) || ""}
            {(type == "agent" && item.agentinfo?.name) || ""}
          </h1>
          {item?.startDate && item?.endDate && (
            <p className="text-xs flex items-center gap-1 whitespace-nowrap">
              <LuCalendar size={12} color="black" />
              <span className="text-[#0F0F0F] text-[12px] font-medium">
                {`${
                  dayjs(item?.startDate).format("D MMM YY") +
                  " to " +
                  dayjs(item?.endDate).format("D MMM YY")
                }`}
              </span>
            </p>
          )}
        </div>
        <div className="px-0">
          <img
            id="account-menu"
            src={MoreIcon}
            className="w-5 cursor-pointer"
            onClick={handleClick}
          />
          <StyledMenu
            id="account-menu"
            MenuListProps={{
              "aria-labelledby": "demo-customized-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseMenu}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
                mt: 1,
                minWidth: "140px",
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {pagePermission?.update_permission == 1 && (
              <MenuItem
                onClick={() => {
                  //console.log({ item });
                  handleCloseMenu("edit", item);
                }}
                sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  fontFamily: '"Inter", sans-serif',
                }}
              >
                <BorderColorOutlined
                  className="mr-[12px]"
                  fontSize={"small"}
                  htmlColor="#59758a"
                />{" "}
                Edit
              </MenuItem>
            )}
            {pagePermission?.delete_permission == 1 && (
              <MenuItem
                onClick={() => handleOpenDel(item)}
                sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  fontFamily: '"Inter", sans-serif',
                }}
              >
                <DeleteOutline
                  className="mr-[12px]"
                  fontSize={"small"}
                  htmlColor="#59758a"
                />{" "}
                Delete
              </MenuItem>
            )}
          </StyledMenu>
        </div>
      </div>
    </div>
  );
};
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "0px 0px 0px 0px rgb(224, 224, 224), 0px 0px 0px 1px rgba(0, 0, 0, 0.05), 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default SlotItem;
